import { render, staticRenderFns } from "./IPFSVideo.vue?vue&type=template&id=9200f3f6&scoped=true&"
import script from "./IPFSVideo.vue?vue&type=script&lang=js&"
export * from "./IPFSVideo.vue?vue&type=script&lang=js&"
import style0 from "./IPFSVideo.vue?vue&type=style&index=0&id=9200f3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9200f3f6",
  null
  
)

/* custom blocks */
import block0 from "./IPFSVideo.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports